// extracted by mini-css-extract-plugin
export default {"Header":"Y7I0kNWPYjpoG0LStQb_"};